// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_p-0";
export var colorSwatch = "_p-5";
export var fillWidth = "_p-4";
export var iconButton = "_p-2";
export var iconWrapper = "_p-3";
export var shadow = "_p-6";
export var xs = "_p-1";